'use client';

import { cn } from '@/lib/utils';

export function CategoryTabButton({ onClick, isOpen }) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'fixed left-0 top-1/2 -translate-y-1/2 z-50 transition-all duration-300 md:hidden group',
        isOpen ? 'translate-x-64' : 'translate-x-0'
      )}
      aria-label="Open categories"
    >
      <div className="relative">
        {/* Glow effect */}
        <div className="absolute inset-0 bg-violet-500 blur-md opacity-50 group-hover:opacity-100 transition-opacity duration-300 rounded-r-full" />

        {/* Button content */}
        <div className="relative bg-black/80 backdrop-blur-md border border-l-0 border-violet-500/50 text-violet-400 p-3 rounded-r-xl shadow-[0_0_15px_rgba(139,92,246,0.3)] group-hover:shadow-[0_0_25px_rgba(139,92,246,0.5)] group-hover:text-white group-hover:border-violet-400 transition-all duration-300 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="transition-transform duration-300 group-hover:scale-110"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </div>
      </div>
    </button>
  );
}
